import {put, takeLatest, call} from 'redux-saga/effects';
import * as settingsService from "../../../services/settingsService";
import {
    GET_SETTINGS,
    GET_SETTINGS_SUCCESS,
    GET_SETTINGS_ERROR,
}
    from "../../actions/settings"

function* getSettingsSaga(action) {
    try {
       const data  = yield call(settingsService.GetSettings,action.payload)
        
       yield put({
        type: GET_SETTINGS_SUCCESS,
        payload: data
    })


    } catch (error) {
        yield put({
            type: GET_SETTINGS_ERROR,error: error.data
        })
    }
}


export function* getSettingsSagaWatcher() {
    yield takeLatest(GET_SETTINGS, getSettingsSaga)
}